import { SERVICE_CONTENT } from "../utils/constants";
import { TiltSurface } from "./InteractiveSurface";

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="section-heading">
        <span className="eyebrow">What We Do</span>
        <h2>Our Services</h2>
        <p>Everything your money needs, handled by one person you can trust.</p>
      </div>

      <div className="services-grid">
        {SERVICE_CONTENT.map((card) => {
          const Icon = card.icon;
          return (
            <TiltSurface className="service-card tilt-surface" key={card.title}>
              <div className="service-icon">
                <Icon />
              </div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </TiltSurface>
          );
        })}
      </div>
    </section>
  );
};

export default Services;
